import { useTranslation } from 'react-i18next';
import { useAddNotes } from './hooks/useAddNote';
import CustomFormInput from '../../../../commonComponents/CustomFormInput';
import SubmitButton from '../../../../commonComponents/SubmitButton';
import { Box } from '@mui/system';
import { useTheme } from '@mui/material';

const NotesForm = ({ id, handleDrawerClose }) => {
  const { t } = useTranslation();
  const { handleSubmit, control, onSubmit } = useAddNotes(id, handleDrawerClose);
  const theme = useTheme();
  const activeBg = theme.palette.secondary.main;
  const hoverBg = theme.palette.secondary.main + 'CC';
  return (
    <Box component="form" display="flex" flexDirection="column">
      <CustomFormInput name="note" control={control} label={t('Notes')} />
      <SubmitButton
        onClick={handleSubmit(onSubmit)}
        buttonText={t('Add')}
        backgroundColor={activeBg}
        hoverBgColor={hoverBg}
        color="inherit"
      />
    </Box>
  );
};

export default NotesForm;
